import createIcon from '../../createIcon';

/**
 * @component @name InstallMobile
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMThINVY2SDEyVjFINUMzLjkgMSAzIDEuOSAzIDNWMjFDMyAyMi4xIDMuOSAyMyA1IDIzSDE1QzE2LjEgMjMgMTcgMjIuMSAxNyAyMVYxNkgxNVYxOFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNiAxNEwyMSA5TDE5LjU5IDcuNTlMMTcgMTAuMTdWM0gxNVYxMC4xN0wxMi40MSA3LjU5TDExIDlMMTYgMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const InstallMobile = createIcon('InstallMobile', [
  [
    'path',
    {
      d: 'M15 18H5V6H12V1H5C3.9 1 3 1.9 3 3V21C3 22.1 3.9 23 5 23H15C16.1 23 17 22.1 17 21V16H15V18Z',
      key: '14bwv8',
    },
  ],
  [
    'path',
    { d: 'M16 14L21 9L19.59 7.59L17 10.17V3H15V10.17L12.41 7.59L11 9L16 14Z', key: '7v5ll7' },
  ],
]);

export default InstallMobile;
